var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Apptab'),_c('v-container',[_c('h1',[_vm._v("Dina Kommentarer")]),_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.comments,"items-per-page":10},scopedSlots:_vm._u([{key:"item.schedule_name",fn:function(ref){
var item = ref.item;
return [_c('router-link',{attrs:{"to":'/schedule/'+item.schedule_link}},[_vm._v(_vm._s(item.title))])]}}])})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }